<template>

    <div class="statistics-bg">

        <mu-row class="statistics" justify-content="start" align-items="center">
            <mu-col span="12" sm="12" md="10" lg="10" xl="10">

                <!-- Números da estatística -->
                <mu-row v-if="!loading && countTotal() > 0" class="numbers">
                    <mu-col span="12" sm="12" md="4" lg="4" xl="4" v-for="(item,key) in results" :key="key">
                        <mu-dot :color="item.color"></mu-dot> <strong>{{ item.count }}</strong> {{ item.name }}
                    </mu-col>
                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                        <mu-dot color="primary"></mu-dot> <strong>{{ countTotal() }}</strong> Total
                    </mu-col>
                </mu-row>

                <!-- Nâo trouxe nenhuma estatística -->
                <div v-if="countTotal() == 0">
                    Nâo existe dados no momento para carregar as estatísticas.
                </div>

                <!-- Loading de estatísticas -->
                <div class="loading" v-if="loading">
                    <mu-flex justify-content="center" align-items="center">
                        <mu-circular-progress color="primary" :stroke-width="1" :size="20"></mu-circular-progress> <span class="text">Atualizando estatísticas da campanha...</span>
                    </mu-flex>
                </div>

            </mu-col>
            <mu-col span="12" sm="12" md="2" lg="2" xl="2">

                <!-- Botão para atualizar -->
                <div class="btn-refresh">
                    <mu-button round color="#eef1f3" textColor="#666" @click="load()">
                        <font-awesome-icon icon="sync" class="icon-md icon-margin-left"/>
                        Atualizar
                    </mu-button>
                </div>

            </mu-col>
        </mu-row>
    </div>

</template>

<script>
    import CampaignsServices from '@/services/services/sms'

    export default {
        name: 'card-campaign-statistics',
        props: ['id'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                loading: false,
                results: []
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted () {
            this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Método responsavel por carregar as estatisticas de status de
             * uma determinada campanha
             */
            async load () {
                try {
                    this.loading = true

                    let result = await CampaignsServices.status(this.id)

                    if (result && result.status) {
                        this.results = result.results
                        return
                    }

                    throw new Error()
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível atualizar os status.')
                    this.$eventHub.$emit('loading', false)
                } finally {
                    this.loading = false
                }
            },

            /**
             * Faz a contagem utilizando reduce no resultado
             */
            countTotal () {
                if (this.results && this.results.length === 0) {
                    return 0
                }
                return this.results.reduce((total, item) => {
                    return total + item.count
                }, 0)
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .statistics-bg
        background lighten($grey, 85%)
        padding 15px
        border-top 1px #ddd dashed

    .statistics
        color #777

        .btn-refresh
            text-align center
            padding-top 5px
            border-top 1px #ccc solid
            margin-top 10px

        .numbers
            strong
                padding-left 4px

        .loading
            text-align center
            .text
                padding-left 10px
                font-size 12px
                display none

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)

        .statistics

            .btn-refresh
                padding-top 0
                border-top 0
                margin-top 0

            .loading
                .text
                    display inline-block

</style>
